(function () {
  const nativeSubmit = HTMLFormElement.prototype.submit;
  const MESSAGE = "Please upload required photos before checkout.";

  /**
   * Returns the shared telemetry bridge loaded synchronously in theme.liquid.
   *
   * @returns {object|null}
   */
  function getCartGuardTelemetry() {
    return window.LegitGrails && window.LegitGrails.telemetryBridge
      ? window.LegitGrails.telemetryBridge
      : null;
  }

  /**
   * Sends a cart-upload validation exception through the shared telemetry bridge.
   *
   * The bridge queues calls until the deferred Faro runtime is ready.
   *
   * @param {*} error
   * @param {object} context
   * @returns {void}
   */
  function pushCartGuardError(error, context) {
    try {
      const telemetry = getCartGuardTelemetry();
      if (!telemetry || typeof telemetry.pushError !== "function") return;

      telemetry.pushError(error, context);
    } catch (telemetryError) {
      // Telemetry must never break checkout protection.
    }
  }

  function getValidationMarkers() {
    return Array.prototype.slice.call(
      document.querySelectorAll("[data-upload-cart-invalid]")
    );
  }

  function getInvalidValidationMarkers() {
    return getValidationMarkers().filter(function (marker) {
      return marker.getAttribute("data-upload-cart-invalid") === "true";
    });
  }

  function cartHasInvalidUploadItems() {
    return getInvalidValidationMarkers().length > 0;
  }

  function isCartForm(form) {
    if (!form || form.tagName !== "FORM") return false;

    const action = form.getAttribute("action") || "";
    let normalizedAction = "";

    try {
      normalizedAction = new URL(action, window.location.origin).pathname.replace(/\/$/, "");
    } catch (e) {
      normalizedAction = action.split("?")[0].replace(/\/$/, "");
    }

    return form.id === "cart" || normalizedAction === "/cart";
  }

  function isCheckoutSubmission(event) {
    const submitter = event && event.submitter;

    if (!submitter) return true;
    if (submitter.name === "update") return false;

    return (
      submitter.name === "checkout" ||
      submitter.id === "checkout" ||
      submitter.hasAttribute("data-cart-submit")
    );
  }

  function getSubmitterContext(submitter) {
    if (!submitter) return {};

    return {
      submitterName: submitter.name || "",
      submitterId: submitter.id || "",
      submitterType: submitter.type || "",
      submitterText: String(submitter.textContent || "").trim().slice(0, 120),
    };
  }

  /**
   * Builds support/debug context for a cart checkout block.
   *
   * @param {string} phase
   * @param {HTMLFormElement|null} form
   * @param {HTMLElement|null} submitter
   * @returns {object}
   */
  function getCartGuardContext(phase, form, submitter) {
    const markers = getValidationMarkers();
    const invalidMarkers = getInvalidValidationMarkers();
    const invalidCartItems = invalidMarkers.map(function (marker) {
      return marker.getAttribute("data-upload-cart-item-key") ||
        marker.getAttribute("data-key") ||
        marker.id ||
        marker.className ||
        "unknown";
    });

    return {
      phase,
      path: window.location.pathname,
      formId: form && form.id ? form.id : "",
      formAction: form ? form.getAttribute("action") || "" : "",
      validationMarkerCount: markers.length,
      invalidValidationMarkerCount: invalidMarkers.length,
      invalidCartItems: invalidCartItems.join(","),
      ...getSubmitterContext(submitter),
    };
  }

  /**
   * Reports a blocked checkout attempt to Faro through the shared bridge.
   *
   * @param {string} phase
   * @param {HTMLFormElement|null} form
   * @param {HTMLElement|null} submitter
   * @returns {void}
   */
  function reportBlockedCheckout(phase, form, submitter) {
    const error = new Error("[cartUploadValidation] Checkout blocked because required upload data is missing");
    pushCartGuardError(error, getCartGuardContext(phase, form, submitter));
  }

  function showValidationMessage() {
    const messages = document.querySelectorAll("[data-upload-cart-validation-message]");

    messages.forEach(function (message) {
      message.hidden = false;
      message.textContent = MESSAGE;
    });
  }

  function setCheckoutButtonsState() {
    const invalid = cartHasInvalidUploadItems();
    const buttons = document.querySelectorAll(
      'form#cart [name="checkout"], form#cart [data-cart-submit], form#cart #checkout'
    );

    buttons.forEach(function (button) {
      if (button.name === "update") return;

      if (invalid) {
        button.disabled = true;
        button.setAttribute("aria-disabled", "true");
        button.setAttribute("data-upload-validation-disabled", "true");
      } else if (button.getAttribute("data-upload-validation-disabled") === "true") {
        button.disabled = false;
        button.setAttribute("aria-disabled", "false");
        button.removeAttribute("data-upload-validation-disabled");
      }
    });
  }

  function safeSetCheckoutButtonsState(phase) {
    try {
      setCheckoutButtonsState();
    } catch (error) {
      pushCartGuardError(error, {
        ...getCartGuardContext(phase, document.getElementById("cart"), null),
        errorName: error && error.name ? error.name : "Error",
        errorMessage: error && error.message ? error.message : String(error || ""),
      });
    }
  }

  document.addEventListener(
    "submit",
    function (event) {
      const form = event.target;

      if (!isCartForm(form)) return;
      if (!isCheckoutSubmission(event)) return;
      if (!cartHasInvalidUploadItems()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      reportBlockedCheckout("cart_upload_validation_submit_blocked", form, event.submitter);
      showValidationMessage();
      safeSetCheckoutButtonsState("cart_upload_validation_submit_blocked_state_update");
    },
    true
  );

  HTMLFormElement.prototype.submit = function () {
    if (isCartForm(this) && cartHasInvalidUploadItems()) {
      reportBlockedCheckout("cart_upload_validation_native_submit_blocked", this, null);
      showValidationMessage();
      safeSetCheckoutButtonsState("cart_upload_validation_native_submit_blocked_state_update");
      return;
    }

    nativeSubmit.call(this);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      safeSetCheckoutButtonsState("cart_upload_validation_dom_ready_state_update");
    });
  } else {
    safeSetCheckoutButtonsState("cart_upload_validation_initial_state_update");
  }
})();
